const avatarMale = require("@/assets/images/home/avatar02.png"); // 男
const avatarFemale = require("@/assets/images/home/avatar01.png"); // 女

// sex: 1 男 / 0 女；未设置时默认男
export const getAvatarSrcBySex = (sex) => {
  if (sex === 0 || sex === "0") return avatarFemale;
  return avatarMale;
};

export const getAvatarOnErrorBySex = (sex) => {
  return `this.src="${getAvatarSrcBySex(sex)}"`;
};

/** 拼接用户头像 URL，带 cache bust；无头像则按性别默认图 */
export const getUserAvatarUrl = (userInfo, downloadURL) => {
  const info = userInfo || {};
  if (!info.avatar) return getAvatarSrcBySex(info.sex);
  const base = `${downloadURL}${info.avatar}`;
  const ts = info._avatarTs;
  if (!ts) return base;
  return base.indexOf('?') > -1 ? `${base}&_t=${ts}` : `${base}?_t=${ts}`;
};

// 身份
const getDefaultState = () => {
  return {
    token: undefined,
    fileToken: undefined,
    role: '', //用户当前身份
    roleId: undefined,
    userInfo: {}, // 用户信息
    isAdmin: false,
    // attendedProject: [],
    defaultAvatarSrc: avatarMale, // 默认头像地址（可直接给 img src）
    defaultAvatar: getAvatarOnErrorBySex(1), // onerror 用
    rectAvatar: `this.src="${require("@/assets/images/home/avatar-rectangle.png")}"`, //长条头像
    loadingConfig: {
      lock: true,
      text: 'Loading',
      background: 'rgba(255, 255, 255, 0.7)'
    },
    currentProject: {},
    userRoleList: [],
    // 管理后台预览模式：read_only 时 header/面包屑不可点
    pv: sessionStorage.getItem('pv') || '',
  }
}
const state = getDefaultState();
const mutations = {
  getToken(state, res) {
    state.token = res;
  },
  getFileToken(state, res) {
    state.fileToken = res;
  },
  getRole(state, res) {
    state.role = res;
  },
  getRoleId(state, res) {
    state.roleId = res;
  },
  getIsAdmin(state, res) {
    state.isAdmin = res;
  },
  // getAttendentList(state, res) {
  //   state.attendedProject = res;
  //   // state.currentProject = res[0]
  // },
  getCurrentProject(state, res) {
    state.currentProject = res
  },
  getUserInfo(state, res) {
    state.userInfo = { ...(res || {}), _avatarTs: Date.now() };
    // 按性别更新默认头像：1男→avatar02，0女→avatar01
    const sex = state.userInfo.sex;
    state.defaultAvatarSrc = getAvatarSrcBySex(sex);
    state.defaultAvatar = getAvatarOnErrorBySex(sex);
  },
  getUserRoleList(state, res) {
    state.userRoleList = res;
    state.roleId = res[0].id;
    state.role = res[0].value;
  },
  getPv(state, res) {
    state.pv = res || '';
    if (res) {
      sessionStorage.setItem('pv', res);
    } else {
      sessionStorage.removeItem('pv');
    }
  },
  resetModuleState(state, res) {
    Object.assign(state, getDefaultState())
  }
}

const getters = {
  // 按指定性别取 onerror 字符串，列表展示他人头像时可用：avatarOnErrorBySex(item.sex)
  avatarOnErrorBySex: () => (sex) => getAvatarOnErrorBySex(sex),
  avatarSrcBySex: () => (sex) => getAvatarSrcBySex(sex),
  userAvatarUrl: (state) => (downloadURL) => getUserAvatarUrl(state.userInfo, downloadURL),
}

export default {
  state,
  mutations,
  getters,
};
